import FJVersionConfig from '../FJVersionConfig';
import { LOCAL } from '../../constants/FJEvnConstant';
const environment = import.meta.env.MODE;

export default {
    defaultFreeLimit: 2,
    historyListType: 32,
    unitPrice: 4, // 一次换发费用
    hairstylePath:
        environment === LOCAL
            ? `/public/resource/hairstyle-changer/hairstyle/`
            : `https://resource.flexclip.com/app/ai-tools/resource/hairstyle-changer/hairstyle/`,
    // 和 头像生成共享
    hairColorPath:
        environment === LOCAL
            ? `/public/resource/hairstyle-changer/hair-color/`
            : `https://resource.flexclip.com/app/ai-tools/resource/hairstyle-changer/hair-color/`,
    freeLimitType: 'hairstyle-changer',
    currentMenuName: 'ai-hairstyle-changer',
    hairstyleChangerCommonPath:
        environment === LOCAL
            ? `/public/resource/hairstyle-changer/`
            : `https://resource.flexclip.com/app/ai-tools/resource/hairstyle-changer/`,

    // image key
    originalImageKey: 'ai/input/hairstyle-changer/',
    resultImageKey: 'ai/export/hairstyle-changer/',

    // empty placeholder
    notImageBoxDesc: 'hairstyle-advertisement-desc',
    notImageBoxTitle: 'hairstyle-advertisement-title',
    notImageBoxVideoUrl:
        environment === LOCAL
            ? `/public/resource/hairstyle-changer/hairstyle-changer-demonstration.mp4?v=${FJVersionConfig.staticPathVersion}`
            : `https://resource.flexclip.com/app/ai-tools/resource/hairstyle-changer/hairstyle-changer-demonstration.mp4?v=${FJVersionConfig.staticPathVersion}`,
};
